import React from "react";
import MasterLayout from "../otherImages/MasterLayout";
import DefaultTopBar from "../components/DefaultTopBar";
import { useDispatch, useSelector } from "react-redux";
import { downloadAssessmentsCSV } from "../redux/slices/documentSlice";
import ClientDocumentsData from "../components/ClientDocumentsData";
import Toast from "../components/Toast";

const CustomerDocuments = () => {
  const dispatch = useDispatch();

  // Get download states from Redux
  const { isDownloadingCSV, downloadCSVError, successMessage } = useSelector(
    (state) => state.document,
  );

  const handleDownloadCSV = () => {
    // Get the local time difference in hours (offset from UTC)
    const localTimeDifference = -new Date().getTimezoneOffset() / 60;

    dispatch(
      downloadAssessmentsCSV({
        local_time_difference: localTimeDifference,
      }),
    );
  };

  return (
    <>
      {/* Toast component for error messages */}
      {downloadCSVError && (
        <Toast
          show={!!downloadCSVError}
          message={downloadCSVError}
          type="error"
          onClose={() => {
            /* Clear error if needed - you may want to dispatch an action to clear the error */
          }}
          duration={3000}
        />
      )}

      {/* Optional: Success toast if needed */}
      {successMessage && (
        <Toast
          show={!!successMessage}
          message={successMessage}
          type="success"
          onClose={() => {
            /* Clear success message if needed */
          }}
          duration={3000}
        />
      )}

      <MasterLayout>
        <DefaultTopBar
          title="Customer Documents"
          btnText2="Download CSV"
          btnLink2="#"
          isApiButton2={true}
          onBtn2Click={handleDownloadCSV}
          isBtn2Loading={isDownloadingCSV}
          btn2LoadingText="Downloading..."
        />
        <ClientDocumentsData />
      </MasterLayout>
    </>
  );
};

export default CustomerDocuments;
